export default __webpack_public_path__ + "static/media/ruta_cinepolis.838f4f9c.png";